import { TaxSubmissionStatus } from "../../core/dtos/TaxSubmissionStatus";

export const getTaxSubmissionStatusTooltipTitleKey = (
    status: TaxSubmissionStatus,
): string =>
    `views.home.components.tax_submissions_table_header_kpi_card.${status.toLowerCase()}.tooltip.title`;

export const getTaxSubmissionStatusTooltipTextKey = (
    status: TaxSubmissionStatus,
): string =>
    `views.home.components.tax_submissions_table_header_kpi_card.${status.toLowerCase()}.tooltip.text`;
